import React from "react";
import { Button } from "react-admin";
import { Popover, List, ListItem, ListItemText } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import notify from "./CustomUseNotify";
// eslint-disable-next-line no-unused-vars
import { generateReport } from "../utils/generateReports";

export default function CustomExportButton(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const closePopover = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleClick = (event, callback) => {
    closePopover(event);
    callback();
  };

  return (
    <React.Fragment>
      <Button
      className='buttonStyle addBorderRadius'
        variant="contained"
        color="secondary"
        disableElevation
        size="small"
        disabled={props.disabled}
        onClick={(event) => {
          if (sessionStorage.getItem("disable_downloads") === "1") {
            notify("Downloads are disabled. Complete the payment if not already done", "warning");
          } else {
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
          }
        }}
      >
        <GetAppIcon />
      </Button>

      <Popover
        open={open}
        onClose={closePopover}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <List component="nav" aria-label="main mailbox folders">
          <ListItem
            button
            onClick={(event) => handleClick(event, props.getCSV)}
          >
            <ListItemText primary="Excel" />
          </ListItem>
          {props.getPDF && (
            <ListItem
              button
              onClick={(event) => handleClick(event, props.getPDF)}
            >
              <ListItemText primary="PDF" />
            </ListItem>
          )}
        </List>
      </Popover>
    </React.Fragment>
  );
}
